import apiClient from './apiClient.js'

export const formService = {
    // Contact form submission
    submitContactForm(data) {
        return apiClient.post('/submissions/contact', data)
    },

    // Enquiry form submission
    submitEnquiryForm(data) {
        return apiClient.post('/submissions/enquiry', data)
    },

    // Newsletter subscription
    subscribeNewsletter(data) {
        return apiClient.post('/submissions/newsletter', data)
    },

    // Career application
    submitCareerApplication(data) {
        return apiClient.post('/submissions/career', data)
    },

    // File upload service (for resumes)
    uploadResume(file) {
        const formData = new FormData()
        formData.append('file', file)
        return apiClient.post('/upload/resume', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}